import { gql } from '@apollo/client';

export const REMOVE_CONTACT_MUTATION = gql`
  mutation RemoveContactMutation($id: String!) {
    removeContact(id: $id)
  }
`;
